export default function specifications() {
	const specifications = document.querySelector('.specifications');

	if(!specifications) {
		return;
	}
	const updateSpecificationsTitleHeight = () => {
		const specificationsTitles = document.querySelectorAll('.specifications__title');

		let widestTitle = 0;
		specificationsTitles.forEach(title => {
			if (title.offsetWidth > widestTitle) {
				widestTitle = title.offsetWidth;
			}
		});
		document.documentElement.style.setProperty('--specifications-title-height', `${widestTitle + 1}px`);
	};

	// Initial call to set the height on load
	updateSpecificationsTitleHeight();

	// Add event listener to update the height on window resize
	window.addEventListener('resize', updateSpecificationsTitleHeight);
}